(function (root) {
  'use strict';

  var familyPatterns = [
    'trail boss', 'big bear', 'brute force', 'king quad', 'land master',
    'sportsman', 'scrambler', 'ranger', 'general', 'xpedition', 'rzr', 'ace',
    'magnum', 'trailblazer', 'xplorer', 'hawkeye', 'phoenix', 'outlaw', 'predator',
    'maverick', 'defender', 'commander', 'outlander', 'renegade',
    'pioneer', 'talon', 'rancher', 'foreman', 'rubicon', 'recon', 'fourtrax', 'trx',
    'mule', 'teryx', 'krx', 'ridge', 'bayou', 'prairie', 'kfx', 'lakota', 'mojave',
    'yxz', 'wolverine', 'viking', 'rhino', 'grizzly', 'kodiak', 'raptor', 'yfz', 'banshee', 'blaster', 'bruin',
    'cforce', 'uforce', 'zforce', 'u10', 'wildcat', 'prowler', 'alterra', 'mud pro',
    'kingquad', 'quadsport', 'vinson', 'gator', 'rtv', 'mxu', 'mongoose', 'fugleman', 'villain'
  ];
  var makeNames = ['polaris', 'can am', 'honda', 'yamaha', 'kawasaki', 'cfmoto', 'suzuki', 'arctic cat', 'john deere', 'kubota', 'kymco', 'segway', 'hisun', 'bobcat', 'argo', 'bombardier'];
  var genericModels = new Set(familyPatterns.concat(['utv', 'atv', 'sxs', 'universal', 'rmax', 'ds', 'hs']));

  function text(value) { return String(value == null ? '' : value); }
  function decode(value) {
    return text(value).replace(/&nbsp;|&#160;/gi, ' ').replace(/&amp;/gi, '&')
      .replace(/&quot;|&#34;/gi, '"').replace(/&#39;|&apos;/gi, "'")
      .replace(/&ndash;|&#8211;/gi, '-').replace(/&mdash;|&#8212;/gi, '-')
      .replace(/&lt;/gi, '<').replace(/&gt;/gi, '>')
      .replace(/&#(\d+);/g, function (_, n) { var v = Number(n); return v <= 65535 ? String.fromCharCode(v) : ''; });
  }
  function normal(value) {
    return decode(value).toLowerCase().replace(/[–—−]/g, '-')
      .replace(/([a-z])['’]s\b/g, '$1')
      .replace(/\bh\s*\.?\s*o\.?\b/g, 'ho')
      .replace(/high[\s-]*lifter/g, 'highlifter').replace(/can[\s-]*am/g, 'can am')
      .replace(/\b([cuz])\s*force\b/g, '$1force')
      .replace(/\bx[\s-]+(mr|rc|rs|ds|xc|tp)\b/g, 'x$1').replace(/\bxt[\s-]*p\b/g, 'xtp')
      .replace(/\b(xp|rzr|teryx|krx)(\d+)\b/g, '$1 $2')
      .replace(/\b(sportsman|scrambler|ranger|trx|yfz|yxz|rmax|hd|ut|rtv|cforce|uforce|zforce)(\d{2,})/g, '$1 $2')
      .replace(/\b(\d{3,4})([rs])\b/g, '$1 $2')
      .replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  }
  function slug(value) { return normal(value).replace(/ /g, '-'); }
  function word(haystack, needle) { return (' ' + haystack + ' ').indexOf(' ' + needle + ' ') !== -1; }
  function unique(values) { return Array.from(new Set(values)); }
  function familyNames(value) {
    var n = normal(value);
    return familyPatterns.filter(function (f) { return word(n, f) && !(f === 'ridge' && /\bridge rider\b/.test(n)); });
  }
  function yearsIn(value, allowShort) {
    var s = decode(value).replace(/[–—−]/g, '-');
    var years = new Set();
    var fragments = [];
    var match;
    var limit = new Date().getUTCFullYear();
    var re = /\b((?:19|20)\d{2})(?:\s*(?:-|to|through)\s*((?:19|20)\d{2}|\d{2})\b|\s*(\+|and (?:newer|later|up)|onwards?\b|up\b))?/gi;
    while ((match = re.exec(s))) {
      var start = Number(match[1]);
      var end = match[2] ? Number(match[2]) : (match[3] ? limit : start);
      if (end < 100) end += Math.floor(start / 100) * 100;
      if (start < 1950 || end > 2035 || end < start || end - start > 70) continue;
      for (var y = start; y <= end; y++) years.add(y);
      fragments.push(match[0]);
    }
    if (allowShort && !years.size) {
      var short = /(?:\(|\[|\bmodel(?:s)?\s+|\byears?\s+)\s*['’]?(\d{2})\s*-\s*['’]?(\d{2})\s*(?:\)|\]|\b)/gi;
      while ((match = short.exec(s))) {
        var a = Number(match[1]), b = Number(match[2]);
        var first = a >= 70 ? 1900 + a : 2000 + a;
        var last = b >= 70 ? 1900 + b : 2000 + b;
        if (first <= last && last <= limit + 1 && last - first <= 40) {
          for (var z = first; z <= last; z++) years.add(z);
          fragments.push(match[0]);
        }
      }
    }
    return {years: Array.from(years).sort(function (a, b) { return a - b; }), explicit: years.size > 0, fragments: fragments};
  }
  function withoutYears(value) {
    return decode(value).replace(/[–—−]/g, '-')
      .replace(/\b(?:19|20)\d{2}(?:\s*(?:-|to|through)\s*(?:(?:19|20)\d{2}|\d{2})\b|\s*\+)?/gi, ' ');
  }
  function extras(value) {
    var n = normal(withoutYears(value));
    var leadingExtras = [];
    if (word(n, '6x6')) leadingExtras.push('6x6');
    if (word(n, '2x4') && !word(n, '4x4')) leadingExtras.push('2x4');
    var families = familyNames(n);
    if (families.length) {
      var first = Math.min.apply(null, families.map(function (f) { return (' ' + n + ' ').indexOf(' ' + f + ' '); }));
      n = n.slice(first);
    }
    n = n.split(/\b(?:brake|pads?|radiator|relocation|axles?|bearings?|bumper|windshield|seat cover|lift kit|snorkel|designed|compatible|features|with a|for a)\b/)[0].trim();
    var values = ['xp', 'pro', 'turbo', 'touring', 'x2', 'highlifter', 'max', 'crew', 'eps', 'sp', 'dps', 'rmax', 'xmr', 'xrc', 'xrs', 'xds', 'xt', 'xtp', 'xc', 'northstar', 'adv', 'premium', 'ultimate', 'deluxe'];
    var found = leadingExtras.concat(values.filter(function (v) { return word(n, v); }));
    if (/\bmud\s+(?:edition|pro|model)\b/.test(n)) found.push('mud');
    if (/\b(?:touring|maverick|rzr|1000|850|570|900)\s+(?:xp )?trail\b|\btrail\s+(?:1000|850|570|900)\b/.test(n)) found.push('trail');
    if (/\b(?:maverick|zforce|outlander|1000|850|900|800)\s+(?:max )?sport\b|\bsport\s+(?:1000|850|900|800)\b/.test(n)) found.push('sport');
    if (/\b(?:\d{3,4}|xp|turbo|rzr|sportsman|scrambler) s\b|\b55\s*(?:in|inch|wide)\b|^s(?:\s+(?:models?|submodels?|edition))?$/.test(n)) found.push('s');
    if (/\b(?:pro|turbo|\d{3,4}|maverick) r\b/.test(n)) found.push('r');
    if (/\b(?:rzr|teryx|xp|pro xp|pro r|pro s|turbo s|turbo r) 4\b|\bpioneer (?:700|1000) 4\b/.test(n)) found.push('four-seat');
    if (/\bpioneer 1000 5\b/.test(n)) found.push('five-seat');
    if (/\bpioneer 1000 6\b/.test(n)) found.push('six-seat');
    return unique(found);
  }
  function splitNegative(value) {
    var s = decode(value);
    var re = /\b(?:does\s+not\s+fit|doesn['’]?t\s+fit|do\s+not\s+fit|will\s+not\s+fit|won['’]?t\s+fit|not\s+compatible(?:\s+with)?|not\s+for|except(?:ing)?|exclud(?:ing|es|ed))\b|\bnon[-\s]*(?=(?:sp|eps|xp|abs|turbo)\b)/i;
    var at = s.search(re);
    return at < 0 ? {include: s, negative: ''} : {include: s.slice(0, at), negative: s.slice(at)};
  }
  function modelsFor(machine) {
    var make = normal(machine.make);
    var models = unique([machine.model, machine.label].concat(machine.aliases || []).map(function (v) {
      var n = normal(v).replace(/^(?:19|20)\d{2} /, '');
      if (n.indexOf(make + ' ') === 0) n = n.slice(make.length + 1);
      return n;
    }).filter(Boolean));
    function identity(model) {
      return unique(model.split(' ').filter(function (t) { return t !== 'ho' && t !== 'efi' && t !== 'edition'; })).sort().join(' ');
    }
    var primary = identity(models[0] || '');
    return models.filter(function (model) { return identity(model) === primary; });
  }
  function modelEvidence(value, machine) {
    var clean = splitNegative(value).include;
    var n = normal(withoutYears(clean));
    var aliases = modelsFor(machine);
    var families = unique(aliases.flatMap(familyNames));
    var presentFamilies = familyNames(n);
    var related = families.some(function (f) { return word(n, f); });
    if (!families.length) related = aliases.some(function (a) { return word(n, a); });
    if (!related) return {level: 'none', related: false};
    var maker = normal(machine.make);
    var listedMakes = makeNames.filter(function (m) { return word(n, m); });
    if (listedMakes.length && listedMakes.indexOf(maker) === -1) return {level: 'different', related: false};
    var rowExtras = extras(clean);
    var chosenExtras = extras(machine.model + ' ' + machine.label);
    var primaryNumbers = normal(machine.model).split(' ').filter(function (w) { return /^\d{2,4}$/.test(w); });
    var rowNumbers = n.split(' ').filter(function (w) { return /^\d{2,4}$/.test(w); });
    var digitMatches = !primaryNumbers.length || primaryNumbers.every(function (v) { return rowNumbers.indexOf(v) !== -1; });
    if (!digitMatches && rowNumbers.length && primaryNumbers.length) return {level: 'different', related: true};
    var conflictingChassis = rowExtras.filter(function (e) { return chosenExtras.indexOf(e) === -1 && !aliases.some(function (a) { return extras(a).indexOf(e) !== -1; }); });
    if (conflictingChassis.length) return {level: 'different', related: true, difference: conflictingChassis.join(', ')};
    var complete = aliases.some(function (alias) {
      if (genericModels.has(alias)) return false;
      var tokens = alias.split(' ').filter(function (t) { return t !== 'ho' && t !== 'efi' && t !== 'edition'; });
      if (!tokens.every(function (t) { return word(n, t); })) return false;
      return chosenExtras.every(function (e) { return rowExtras.indexOf(e) !== -1; });
    });
    var modelNumbers = unique(rowNumbers);
    var compositeFamily = /\bteryx krx\b|\b(?:fourtrax )?foreman(?: rubicon)?\b|\bfourtrax (?:rancher|recon)\b/.test(n) && presentFamilies.length <= 3;
    var ambiguous = (presentFamilies.length > 1 && !(compositeFamily && modelNumbers.length <= 1)) ||
      (modelNumbers.length > 1 && yearsIn(clean, false).fragments.length > 1);
    if (modelNumbers.length > 1 && rowExtras.length && !/\b\d{2,4}(?:\s*[/\-]\s*\d{2,4})+\b/.test(withoutYears(clean))) ambiguous = true;
    if (!families.length && listedMakes.indexOf(maker) === -1) complete = false;
    if (ambiguous) complete = false;
    return {level: complete ? 'specific' : 'broad', related: true, ambiguous: ambiguous};
  }
  function splitRows(value) {
    var s = text(value).replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, ' ')
      .replace(/<\/?(?:td|th)\b[^>]*>/gi, ' ')
      .replace(/<\/?(?:li|p|div|tr|h[1-6]|ul|ol)\b[^>]*>|<br\b[^>]*>/gi, '\n')
      .replace(/<[^>]*>/g, ' ');
    var rows = [];
    decode(s).split(/[\r\n]+/).forEach(function (block) {
      var priorFamily = '';
      block.split(/;|\s+\|\s+|\.\s+(?=[A-Z0-9])/).forEach(function (part) {
        var row = part.trim().replace(/\s+/g, ' ');
        if (!row) return;
        var families = familyNames(row);
        if (families.length === 1) priorFamily = families[0];
        else if (!families.length && priorFamily && /^(?:(?:\d{2,4})\b|touring\b|x2\b|xp\b|6x6\b)/i.test(row)) row = priorFamily + ' ' + row;
        rows.push(row);
      });
    });
    return rows;
  }
  function explicitExclusion(rows, machine) {
    var targetExtras = extras(machine.model + ' ' + machine.label);
    for (var i = 0; i < rows.length; i++) {
      var pieces = splitNegative(rows[i]);
      if (!pieces.negative) continue;
      var base = modelEvidence(pieces.include, machine);
      var neg = pieces.negative.replace(/\b(?:does\s+not\s+fit|doesn['’]?t\s+fit|do\s+not\s+fit|will\s+not\s+fit|won['’]?t\s+fit|not\s+compatible(?:\s+with)?|not\s+for|except(?:ing)?|exclud(?:ing|es|ed))\b|\bnon[-\s]*(?=(?:sp|eps|xp|abs|turbo)\b)/i, '');
      neg = neg.split(/[,;]\s*(?:but\s+)?(?:fits?|works?\s+with|compatible\s+with)\b/i)[0];
      var negFamilies = familyNames(neg);
      var negModel = modelEvidence(neg, machine);
      var negExtras = extras(neg);
      var yearData = yearsIn(neg, false);
      var baseYears = yearsIn(pieces.include, false);
      var applicableYears = yearData.explicit ? yearData : baseYears;
      var includesYear = !applicableYears.explicit || applicableYears.years.indexOf(Number(machine.year)) !== -1;
      var relevantBase = base.level === 'specific' || base.level === 'broad' || (!familyNames(pieces.include).length && !negFamilies.length);
      var excludedTrim = neg.split(/,|\band\b|\bor\b/i).some(function (part) {
        var trim = extras(part);
        var numbers = normal(withoutYears(part)).split(' ').filter(function (n) { return /^\d{2,4}$/.test(n); });
        return trim.length && numbers.every(function (n) { return word(normal(machine.model), n); }) && trim.every(function (e) { return targetExtras.indexOf(e) !== -1; });
      });
      if (includesYear && (negModel.level === 'specific' || (relevantBase && excludedTrim))) return rows[i];
      if (base.level === 'specific' && yearData.explicit && includesYear && !negFamilies.length && !negExtras.length) return rows[i];
    }
    return '';
  }
  function parseMatrix(value) {
    var v = value;
    if (typeof v === 'string') { try { v = JSON.parse(v); } catch (_) { return null; } }
    return v && typeof v === 'object' ? v : null;
  }
  function matrixYears(application) {
    var source = application.years == null ? application.year : application.years;
    return unique((Array.isArray(source) ? source : [source]).flatMap(function (entry) {
      if (/^(?:19|20)\d{2}$/.test(text(entry))) return [Number(entry)];
      return yearsIn(entry, false).years;
    }));
  }
  function result(status, reason, evidence) {
    var r = {status: status, reason: reason};
    if (evidence) r.evidence = text(evidence).slice(0, 450);
    return r;
  }
  function classify(product, machine) {
    if (product && product.year && machine && (machine.title || machine.tags)) { var swap = product; product = machine; machine = swap; }
    product = product || {};
    machine = machine || {};
    if (!machine.make || !machine.model || !/^\d{4}$/.test(text(machine.year))) return result('check', 'Choose a complete machine.');
    var aliases = modelsFor(machine);
    if (aliases.every(function (a) { return genericModels.has(a); })) return result('check', 'Choose the specific model.');
    var title = text(product.title);
    var tags = (Array.isArray(product.tags) ? product.tags : []).map(function (t) { return text(t).toLowerCase().trim(); });
    var makeSlug = slug(machine.make);
    var makeTags = unique(tags.filter(function (t) { return /^make[:_]/.test(t); }).map(function (t) { return slug(t.slice(5)); }));
    if (makeTags.length && makeTags.indexOf(makeSlug) === -1) return result('excluded', 'The product explicitly lists a different vehicle make.');
    var rows = splitRows(product.description_html || product.descriptionHtml || product.description || '');
    var exclusion = explicitExclusion(rows.concat(title), machine);
    if (exclusion) return result('excluded', 'The product lists an exclusion for this model or year.', exclusion);
    var matrix = parseMatrix(product.matrix);
    var apps = matrix && Array.isArray(matrix.applications) ? matrix.applications : [];
    var matrixRows = apps.filter(function (a) { return normal(a.make) === normal(machine.make) && !genericModels.has(normal(a.model)) && modelEvidence(a.make + ' ' + a.model, machine).level === 'specific'; });
    var exactMatrix = matrixRows.find(function (a) {
      var ys = matrixYears(a);
      return ys.indexOf(Number(machine.year)) !== -1;
    });
    if (exactMatrix) return result(exactMatrix.constraint || matrix.requires_component ? 'check' : 'listed', exactMatrix.constraint || matrix.requires_component ? 'Check the listed installation requirements.' : 'The product application data lists this model and year.', JSON.stringify(exactMatrix));
    if (matrixRows.length) return result('excluded', 'The application data lists different years for this model.');
    if (tags.indexOf('fitment:component-compatibility') !== -1 || tags.indexOf('fitment:not-applicable') !== -1) return result('check', 'Compatibility depends on the component or installation.');
    var specificRows = [];
    var broadRows = [];
    var matchingRows = [];
    var wrongModelRows = [];
    var ambiguousRows = [];
    rows.forEach(function (row) {
      var ev = modelEvidence(row, machine);
      var yd = yearsIn(splitNegative(row).include, false);
      if (ev.ambiguous) ambiguousRows.push(row);
      if (ev.level === 'specific' && yd.explicit) {
        specificRows.push(row);
        if (yd.years.indexOf(Number(machine.year)) !== -1) matchingRows.push(row);
      } else if (ev.level === 'specific' || ev.level === 'broad') broadRows.push(row);
      else if (ev.level === 'different' && yd.explicit) wrongModelRows.push(row);
    });
    var titleEv = modelEvidence(title, machine);
    var titleYears = yearsIn(splitNegative(title).include, true);
    if (matchingRows.length) {
      if (titleEv.level === 'specific' && titleYears.explicit && titleYears.years.indexOf(Number(machine.year)) === -1) return result('check', 'The title and detailed fitment list conflicting years; confirm with the supplier.', matchingRows[0]);
      var titleModels = unique(normal(withoutYears(title)).split(' ').filter(function (n) { return /^\d{2,4}$/.test(n); }));
      if (titleEv.level === 'different' && titleEv.difference && titleModels.length <= 1 && familyNames(title).length === 1) return result('check', 'The title and detailed fitment name different configurations; confirm the exact application.', matchingRows[0]);
      return result('listed', 'The product description lists this model and year.', matchingRows[0]);
    }
    if (specificRows.length) return result('excluded', 'The detailed fitment lists different years for this model.', specificRows[0]);
    var exactKeys = aliases.filter(function (a) { return !genericModels.has(a) && extras(machine.model + ' ' + machine.label).every(function (e) { return extras(a).indexOf(e) !== -1; }); }).map(function (a) { return 'fitment:' + machine.year + '-' + makeSlug + '-' + slug(a); });
    var exact = tags.find(function (t) { return exactKeys.indexOf(t) !== -1; });
    if (exact && !wrongModelRows.length && !ambiguousRows.length) return result('listed', 'The product application tag lists this model and year.', exact);
    var modelTags = unique(tags.filter(function (t) { return /^model:/.test(t); }).map(function (t) { return t.slice(6); }));
    var tagYears = [];
    tags.forEach(function (t) {
      if (/^year_\d{4}$/.test(t)) tagYears.push(Number(t.slice(5)));
      if (/^years?:/.test(t)) tagYears = tagYears.concat(yearsIn(t.slice(t.indexOf(':') + 1), false).years);
    });
    if (!wrongModelRows.length && !ambiguousRows.length && makeTags.length === 1 && modelTags.length === 1 && makeTags[0] === makeSlug && exactKeys.indexOf('fitment:' + machine.year + '-' + makeSlug + '-' + modelTags[0]) !== -1) {
      if (tagYears.indexOf(Number(machine.year)) !== -1) return result('listed', 'The product lists one specific model with a matching year.');
      if (tagYears.length) return result('excluded', 'The product lists different years for this model.');
    }
    if (titleEv.level === 'specific' && titleYears.explicit && !wrongModelRows.length && !ambiguousRows.length) {
      if (titleYears.years.indexOf(Number(machine.year)) !== -1) return result('listed', 'The product title lists this model and year.', title);
      return result('excluded', 'The product title lists different years for this model.', title);
    }
    if (titleEv.level === 'different' && !broadRows.length) return result('excluded', 'The product lists a different model or configuration.');
    if (titleEv.related || broadRows.length || modelTags.some(function (t) { return modelEvidence(t, machine).related; })) return result('check', 'Confirm the exact year, trim, and installation requirements.');
    return result('excluded', 'No matching model information was found.');
  }

  var api = {classify: classify, normalize: normal, modelEvidence: modelEvidence, yearsIn: yearsIn, splitRows: splitRows};
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.MOBMachineMatch = api;
})(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : this));
